<template>
  <div style="background-color: #f9fafc;">
    <div class="grey_small_font item" style="margin-left: 1.3rem; padding-top: 1.3rem">
      <span style="font-weight: bold;">{{$t('PAYORDERPAGE.PaymentSolutions')}}</span>
      <div style="margin-left: 1.3rem; padding-top: 1.3rem">
        <el-radio-group v-model="payMethod" @input="inputPayMenthod">
          <el-radio v-for="item in payListOptions" v-show="item.showType" :key="item.id" :label="item.id">
            <!-- <svg-icon icon-class="weixinPay" class="showmap_icon_style"></svg-icon> -->
            {{ item.name }}
          </el-radio>
        </el-radio-group>
      </div>
    </div>
    <div class="nav">
      <!-- 支付按钮 -->
      <div id="box3" style="padding-bottom: 1.3rem">
        <el-row>
          <button v-show="cusDepProPayRule.payShowType" class="s_btn s_btn_small" @click="payClick" :disabled="!isSubmitButton" style="width: 17.6rem">
            <span>{{$t('CREDITCARD.PAYBUTTON')}}</span>
          </button>
        </el-row>
      </div>
    </div>
    <!-- <div v-html="aliPayInfo" style="display:none">{{aliPayInfo}}</div> -->
    <el-dialog :title="payInfo.payTitle" v-model="payDialog" width="40rem" class="cancel_dialog">
      <el-divider class="title-headerDivider"></el-divider>
      <div style="padding: 15px">{{$t('PAYORDERPAGE.Amount')}}
        <span style="color: #f70; font-size: 22px">{{payInfo.currencyCode + payInfo.payAmount}}</span>
      </div>
      <div v-show="payMethod == 2" id="qrcode-container">
        <div id="QRCode"></div>
      </div>
      <div v-show="payMethod == 1">
        <iframe :srcdoc="payInfo.aliPayInfo" frameborder="no" border="0" marginwidth="0" marginheight="0" scrolling="no" width="100" height="100" style="overflow: hidden"></iframe>
      </div>
      <div style="padding: 15px">
        <span>{{ payInfo.payBottomMsg }}</span>
      </div>
    </el-dialog>
    <!-- 快钱支付弹窗 -->
    <el-dialog :title="payInfo.payTitle" v-model="KQPayDialog" width="560px" class="cancel_dialog">
      <div class="add-guest-div">
        <el-button size="default" class="add-guest-btn" @click="addCreditCard()">
          {{ $t("BANNERINFO.ADDBANNERMAINTAIN") }}
        </el-button>
      </div>
      <el-divider class="title-headerDivider"></el-divider>
      <el-form :model="KQPayInfo" :inline="true">
        <Loading :loading="pcPayLoading" />
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.BANKCODENAME')" prop="activiteName" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-select v-model="creditCardNo" filterable :placeholder="$t('MESSAGE.PLEASESELECT')" @change="bankCodeChange">
                <el-option v-for="item in PayOrderInfo.creditCardInfo" :key="item.id" :label="item.joinBank" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.CREDITCARDTYPE')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-select v-model="KQPayInfo.creditCardType" filterable :placeholder="$t('MESSAGE.PLEASESELECT')" style="float: right" disabled>
                <el-option v-for="item in PayOrderInfo.creditCardType" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
              <!-- <el-input v-model="KQPayInfo.creditCardType" autocomplete="off" class="myinput_inner myinput"></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.CREDITCARDNAME')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-input v-model="KQPayInfo.creditCardName" autocomplete="off" class="myinput_inner myinput" disabled></el-input></el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="12" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.CREDITCARDNO')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <el-input v-model="KQPayInfo.creditCardNo" autocomplete="off" class="myinput_inner myinput" disabled></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <span style="color: #fc6640;">{{ PayOrderInfo.isSigning?$t('CREDITCARD.SIGNING'):$t('CREDITCARD.UNSIGNING')}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.CARDTYPE')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-select v-model="KQPayInfo.cardType" filterable :placeholder="$t('MESSAGE.PLEASESELECT')" disabled>
                <el-option v-for="item in PayOrderInfo.cardType" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <!-- <el-input v-model="KQPayInfo.cardType" autocomplete="off" class="myinput_inner myinput"></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.CARDID')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-input v-model="KQPayInfo.cardID" autocomplete="off" class="myinput_inner myinput" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.CREDITCARDDATE')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-input v-model="KQPayInfo.creditCardDate" autocomplete="off" class="myinput_inner myinput" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.MOBILEPHONE')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-input v-model="KQPayInfo.mobilePhone" autocomplete="off" class="myinput_inner myinput" disabled></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size" v-if="!PayOrderInfo.isSigning">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.CVV')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-input v-model="KQPayInfo.cvv" autocomplete="off" class="myinput_inner myinput"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size" v-if="!PayOrderInfo.isSigning">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.CAPTCHA')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item>
              <el-input :maxlength="6" v-model="KQPayInfo.captcha" autocomplete="off" class="myinput_inner myinput" @input="clearNoNumCaptcha()"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item>
              <el-button class="add-guest-btn" :disabled="countdown > 0 " @click="getTcapcha">
                {{ countdown > 0 ? $t('CREDITCARD.GETCAPTCHA') + '(' + countdown + $t('CREDITCARD.COUNTDOWN'): $t('CREDITCARD.GETCAPTCHA')}}
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size" style="display: flex; justify-content: center;">
          <el-button class="add-guest-btn" style="padding: 15px 70px;" @click="kqTransactionPayments()">
            {{$t('CREDITCARD.PAYBUTTON')}}
          </el-button>
        </el-row>
      </el-form>
    </el-dialog>
    <!-- 新增信用卡弹窗 -->
    <el-dialog :title="payInfo.payTitle" v-model="addCreditCardDialog" width="560px" class="cancel_dialog">
      <el-divider class="title-headerDivider"></el-divider>
      <el-form :model="creditCardInfos" :inline="true" :rules="addCreditCardRules" ref="addCreditCardRules">
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.CREDITCARDTYPE')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="creditCardType">
              <el-select v-model="creditCardInfos.creditCardType" filterable :placeholder="$t('MESSAGE.PLEASESELECT')" style="float: right">
                <el-option v-for="item in PayOrderInfo.creditCardType" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.CREDITCARDNAME')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="creditCardName">
              <el-input v-model="creditCardInfos.creditCardName" autocomplete="off" class="myinput_inner myinput" :placeholder="$t('CREDITCARD.VALIDATECREDITCARDNAME')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.CREDITCARDNO')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="creditCardNo">
              <el-input v-model="creditCardInfos.creditCardNo" autocomplete="off" class="myinput_inner myinput" :placeholder="$t('CREDITCARD.VALIDATECREDITCARDNO')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.CARDTYPE')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="cardType">
              <el-select v-model="creditCardInfos.cardType" filterable :placeholder="$t('MESSAGE.PLEASESELECT')">
                <el-option v-for="item in PayOrderInfo.cardType" :key="item.id" :label="item.name" :value="item.id"></el-option>
              </el-select>
              <!-- <el-input v-model="KQPayInfo.cardType" autocomplete="off" class="myinput_inner myinput"></el-input> -->
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.CARDID')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="cardID">
              <el-input v-model="creditCardInfos.cardID" autocomplete="off" class="myinput_inner myinput" :placeholder="$t('CREDITCARD.VALIDATECARDID')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.BANKNAME')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="bankCodeName">
              <el-select v-model="creditCardInfos.bankCodeName" filterable :placeholder="$t('MESSAGE.PLEASESELECT')">
                <el-option v-for="item in PayOrderInfo.bankInfo" :key="item.id" :label="item.bankName" :value="item.bankCode + '+' + item.bankName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.CREDITCARDDATE')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="creditCardDate">
              <el-input v-model="creditCardInfos.creditCardDate" autocomplete="off" class="myinput_inner myinput" :placeholder="$t('CREDITCARD.VALIDATECREDITCARDDATE')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('CREDITCARD.MOBILEPHONE')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item prop="mobilePhone">
              <el-input v-model="creditCardInfos.mobilePhone" autocomplete="off" class="myinput_inner myinput" :placeholder="$t('CREDITCARD.VALIDATEMOBILEPHONE')"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="content_size">
          <el-col :span="10">
            <el-form-item :label="$t('GUARANTEE.CARDPROPERTY')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item>
              <el-radio-group v-model="creditCardInfos.property">
                <el-radio label="Company">{{$t("GUARANTEE.CARDPROPERTYCOM")}}</el-radio>
                <el-radio label="Personal">{{$t("GUARANTEE.CARDPROPERTYPER")}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row>
        <!-- <el-row :gutter="10" class="content_size">
          <el-col :span="6">
            <el-form-item :label="$t('CREDITCARD.SAVECARDINFOMATION')" class="form-label-field"></el-form-item>
          </el-col>
          <el-col :span="10">
            <el-form-item>
              <el-radio-group v-model="creditCardInfos.saveCard">
                <el-radio label="1">{{$t("CONFIRMATION.MANUALORDER")}}</el-radio>
                <el-radio label="0" style="margin-left: 2rem">{{$t("CONFIRMATION.NOTMANUALORDER")}}</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
        </el-row> -->
      </el-form>
     <template #footer>
      <div class="dialog-footer">
        <el-button type="primary" @click="saveCreditCard()">{{$t("INVOICINGBUTTON.SAVE")}}</el-button>
        <el-button @click="creditCardCancel()">{{$t("INVOICINGBUTTON.CANCEL")}}</el-button>
      </div>
    </template>
    </el-dialog>
  </div>
</template>

<script>
import { hoteltradePay } from "@/api/bookingData.js";
import { checkCreditCard } from "@/api/platformData.js";
import Loading from "@/components/Loading.vue";
import QRCode from "qrcodejs2"; //页面中引入第三方生成二维码工具
export default {
  name: "PCPay",
  inject: ['PayOrderInfo'],
  components: {
    Loading,
  },
  props: {
    cusDepProPayRule: Object,
  },
  data() {
    return {
      pcPayLoading:false,
      payMethod: 0,
      payDialog: false,
      KQPayDialog: false,
      addCreditCardDialog: false,
      isSubmitButton: true,
      payInfo: {
        payTitle: "",
        payBottomMsg:"",
        payAmount: "",
        aliPayInfo: "",
        currencyCode: "",
      },
      creditCardNo:"",
      KQPayInfo: { //支付的信用卡信息
        id:"",
        creditCardType: "",
        creditCardName: "",
        creditCardNo: "",
        cardType: "",
        cardID: "",
        creditCardDate: "",
        mobilePhone: "",
        captcha:"",
        cvv:"",
      },
      creditCardInfos: { //新增信用卡信息
        bankCodeName: "",
        creditCardType: "",
        creditCardName: "",
        creditCardNo: "",
        cardType: "",
        cardID: "",
        creditCardDate: "",
        mobilePhone: "",
        property: "Company",
        saveCard: "1",
      },
      countdown:0,
      cardswipefee: 0.00,
      airplusUatp:"",
    };
  },
  computed: {
    addCreditCardRules() {
      return {
        bankCodeName: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.BANKNAME"),}),trigger: ["blur", "change"],},],
        creditCardType: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.CREDITCARDTYPE"),}),trigger: ["blur", "change"],},],
        creditCardName: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.CREDITCARDNAME"),}),trigger: ["blur", "change"],},],
        creditCardNo: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.CREDITCARDNO"),}),trigger: ["blur", "change"],},],
        cardType: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.CARDTYPE"),}),trigger: ["blur", "change"],},],
        cardID: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.CARDID"),}),trigger: ["blur", "change"],},],
        creditCardDate: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.CREDITCARDDATE"),}),trigger: ["blur", "change"],},],
        mobilePhone: [{required: true,message: this.$t("CREDITCARD.VALIDATEMSG", {Msg: this.$t("CREDITCARD.MOBILEPHONE"),}),trigger: ["blur", "change"],},],
      };
    },
    payListOptions: function () {
      var result = [
        { id: 1, name: this.$t("PAYMENTTYPE.Alipay"),showType:this.cusDepProPayRule.isAlipay },
        { id: 2, name: this.$t("PAYMENTTYPE.WeChatPay"),showType:this.cusDepProPayRule.isWeiXinPay },
        { id: 3, name: this.$t("PAYMENTTYPE.KQ"),showType:this.cusDepProPayRule.isKQPay },
        { id: 4, name: this.$t("PAYMENTTYPE.CTA"),showType:this.cusDepProPayRule.isCTAPay },
      ];
      return result;
    },
  },
  mounted() {
    // console.log(this.PayOrderInfo.orderInfo);
    // debugger;
    // this.payInfo.payAmount = this.PayOrderInfo.orderInfo.bookParam.totalPrice;
    // this.payInfo.currencyCode =
    //   this.$currencySign[this.PayOrderInfo.orderInfo.bookParam.currencyCode];
  },
  methods: {
    getDisplayAmount() {
      console.log("dsds", this.payInfo);
      if (!this.payInfo) return ''
      return (this.payInfo.currencyCode || '') + (this.payInfo.payAmount || '')
    },
    payClick() {
      if (this.payMethod == 0) { return; }
      var bookParam = this.PayOrderInfo.orderInfo.bookParam;
      this.airplusUatp = bookParam.paymentInfo.airplusUatp;
      this.payInfo.payAmount = this.PayOrderInfo.orderTotalPrice();
      this.payInfo.currencyCode = this.$currencySign[bookParam.currencyCode];
      this.PayOrderInfo.openLoading();
      this.payInfo.aliPayInfo = "";
      // 判断支付方式
      if (this.payMethod == 1) {
        // 支付宝
        this.AliPay();
      } else if (this.payMethod == 2) {
        // 微信
        this.WeChatPay();
      } else if (this.payMethod == 3) {
        // 快钱
        this.KQPay();
      } else if (this.payMethod == 4) {
        // 快钱_CTA
        this.KQCTAPay();
      }
    },
    //支付宝支付二维码
    AliPay() {
      let Params = {
        BookingCode: this.PayOrderInfo.orderInfo.bookParam.bookingId,
        SourceType: "PC",
        Channel: 2,
      };
      let that = this;
      hoteltradePay(Params)
        .then(function (response) {
          if (response.code == "200") {
            if (response.data.code == "0") {
              that.payInfo.aliPayInfo = response.data.body;
              that.payInfo.payBottomMsg = that.$t("PAYORDERPAGE.QRCodeMsg_Ali");
              that.payDialog = true;
            } else {
              that.payDialog = false;
            }
          } else {
            that.payDialog = false;
          }
          //关闭弹框
          that.PayOrderInfo.closeLoading();
        })
        .catch(function (error) {
          console.log(error);
          //关闭弹框
          that.PayOrderInfo.closeLoading();
        });
      that.payInfo.payTitle = this.$t("PAYMENTTYPE.Alipay");
      that.isSubmitButton = true;
    },
    //微信支付二维码
    WeChatPay() {
      let Params = {
        BookingCode: this.PayOrderInfo.orderInfo.bookParam.bookingId,
        SourceType: "PC",
        Channel: 3,
      };
      let that = this;
      hoteltradePay(Params)
        .then(function (response) {
          if (response.code == "200") {
            if (response.data.code == "0") {
              that.payDialog = true;
              that.payInfo.payBottomMsg = that.$t("PAYORDERPAGE.QRCodeMsg_Wechat");
              that.$nextTick(() => {
                document.getElementById("QRCode").innerHTML = ""; //获取生成二维码后显示的容器的ID
                that.qrCode = new QRCode("QRCode", {
                  width: 100, //二维码的宽度
                  height: 100, //二维码的高度
                  text: response.data.body, //调用weixincode()方法时后台传的code
                  colorDark: "#000", //二维码颜色
                  colorLight: "#fff", //二维码底色
                });
              });
              //that.payInfo.aliPayInfo = response.data.body;
            } else {
              that.payDialog = false;
            }
          } else {
            that.payDialog = false;
          }
          //关闭弹框
          that.PayOrderInfo.closeLoading();
        })
        .catch(function (error) {
          console.log(error);
          that.payDialog = false;
          //关闭弹框
          that.PayOrderInfo.closeLoading();
        });
      this.payInfo.payTitle = this.$t("PAYMENTTYPE.WeChatPay");
      that.isSubmitButton = true;
    },
    KQPay(){
      this.PayOrderInfo.closeLoading();
      this.countdown = 0;
      this.KQPayDialog = true;
      this.addCreditCardDialog = false;
      if(this.PayOrderInfo.creditCardInfo[0] != undefined){
        this.KQPayInfo = this.PayOrderInfo.creditCardInfo[0];
        this.creditCardNo = this.PayOrderInfo.creditCardInfo[0].joinBank;
        let Param = {
          params: {
            userCreditCardId: this.KQPayInfo.id,
            source:"PC",
          },
        };
        // this.KQPayInfo.cvv = "";
        // this.KQPayInfo.captcha = "";
        this.PayOrderInfo.verifyBankSigning(Param);
      }
      this.payInfo.payTitle = this.$t("PAYMENTTYPE.KQ");
      this.isSubmitButton = true;
    },
    KQCTAPay() {
      let checkParams = {
        params: {
          creditCardNo: this.airplusUatp,
          userCode: this.PayOrderInfo.orderInfo.bookParam.customerCode,
        },
      };
      checkCreditCard(checkParams).then((response) => {
        if (response.code == "200") {
          if(response.data){
            let Params = {
              BookingCode: this.PayOrderInfo.orderInfo.bookParam.bookingId,
              SourceType: "PC",
              Channel: 5,
              BankCardNo:this.airplusUatp,
            };
            let that = this;
            hoteltradePay(Params).then(function (response) {
              if (response.code == "200") {
                if (response.data.code == "0") {
                  that.PayOrderInfo.confirmFlag = true;
                  that.PayOrderInfo.confirmMsg = that.$t("PAYORDERPAGE.PaymentSucceeded");
                  //关闭弹框
                  that.PayOrderInfo.closeLoading();
                } else {
                  that.$message({
                    showClose: true,
                    message: response.data.msg,
                    type: 'warning',
                    center: true,
                    offset:500
                  });
                  //关闭弹框
                  that.PayOrderInfo.closeLoading();
                }
              } else {
                that.PayOrderInfo.confirmFlag = true;
                that.PayOrderInfo.confirmMsg = that.$t("PAYORDERPAGE.PaymentFailed");
                //关闭弹框
                that.PayOrderInfo.closeLoading();
              }
            });
          } else {
            this.PayOrderInfo.confirmFlag = true;
            this.PayOrderInfo.confirmMsg = this.$t("PAYORDERPAGE.CTACheckMsg");
            //关闭弹框
            this.PayOrderInfo.closeLoading();
          }
        } else {
          this.PayOrderInfo.confirmFlag = true;
          this.PayOrderInfo.confirmMsg = this.$t("PAYORDERPAGE.CTACheckMsg");
          //关闭弹框
          this.PayOrderInfo.closeLoading();
        }
      });
    },
    bankCodeChange(val) {
      var arr = this.PayOrderInfo.creditCardInfo.filter((p) => p.id == val);
      if (arr.length > 0) {
        this.PayOrderInfo.kqContractToken = "";
        this.KQPayInfo = this.$options.data().KQPayInfo;
        this.KQPayInfo = arr[0];
        this.creditCardNo = arr[0].joinBank;
        let Param = {
          params: {
            userCreditCardId: this.KQPayInfo.id,
            source:"PC",
          },
        };
        this.PayOrderInfo.verifyBankSigning(Param);
      }
    },
    addCreditCard() {
      Object.assign(this.$data.creditCardInfos, this.$options.data.call(this).creditCardInfos);
      if (this.$refs.addCreditCardRules !== undefined) {
        this.$refs["addCreditCardRules"].resetFields();//重置表单
      };
      this.KQPayDialog = false;
      this.payInfo.payTitle = this.$t("PAYMENTTYPE.KQ");
      this.addCreditCardDialog = true;
    },
    saveCreditCard() {
      this.$refs["addCreditCardRules"].validate((valid) => {
        if (valid) {
          let data = {
            source:"PC",
            userCode: this.PayOrderInfo.orderInfo.bookParam.customerCode,
            userId: this.KQPayInfo.userID,
            creditCardName: this.creditCardInfos.creditCardName,
            creditCardNo: this.creditCardInfos.creditCardNo,
            creditCardDate: this.creditCardInfos.creditCardDate,
            creditCardType: this.creditCardInfos.creditCardType,
            bankCode: this.creditCardInfos.bankCodeName.split("+")[0],
            mobilePhone: this.creditCardInfos.mobilePhone,
            natureCode: this.creditCardInfos.property,
            cardType: this.creditCardInfos.cardType,
            cardID: this.creditCardInfos.cardID,
            saveData: true,//默认保存，不保存的先不做
            createBy: this.PayOrderInfo.orderInfo.bookParam.createdBy,
            loginID: this.PayOrderInfo.orderInfo.bookParam.bookingAgent[0].userId,
            bankCodeName: this.creditCardInfos.bankCodeName.split("+")[1],
            isFirst:true,
          };
          this.PayOrderInfo.addUserCreditCardCallBack(data);
        }
      });
    },
    creditCardCancel() {
      this.KQPayDialog = true;
      this.addCreditCardDialog = false;
    },
    getTcapcha(){
      this.countdown = 59;
      this.PayOrderInfo.tcapchaTimer = setInterval(()=>{
        if(this.countdown >0){
          this.countdown --;
        }else{
          clearInterval(this.PayOrderInfo.tcapchaTimer)
          this.PayOrderInfo.tcapchaTimer = null;
        }
      },1000);
      let data = {
        source:"PC",
        id:this.KQPayInfo.id,
        bookingId: this.PayOrderInfo.orderInfo.bookParam.bookingId,
        cardHolderId: this.PayOrderInfo.orderInfo.bookParam.bookingAgent[0].userId,
        cvv: this.KQPayInfo.cvv,
        customerCode:this.PayOrderInfo.orderInfo.bookParam.customerCode,
      };
      this.PayOrderInfo.kqContract(data);
    },
    kqTransactionPayments(){
      var payStatus = true;
      let Params = {
        BookingCode: this.PayOrderInfo.orderInfo.bookParam.bookingId,
        SourceType: "PC",
        Channel: 4,
        Id:this.KQPayInfo.id,
        cardHolderId: this.PayOrderInfo.orderInfo.bookParam.bookingAgent[0].userId,
      };
      if(!this.PayOrderInfo.isSigning){
        if(this.KQPayInfo.captcha == "" || this.KQPayInfo.captcha == undefined){
          this.PayOrderInfo.confirmFlag = true;
          this.PayOrderInfo.confirmMsg = this.$t('CREDITCARD.VALIDATEMSG', {Msg: $t('CREDITCARD.CAPTCHA')});
          payStatus = false;
        }
        Params.ValidCode = this.KQPayInfo.captcha;
        Params.Token = this.PayOrderInfo.kqContractToken;
      };
      if(payStatus){
        let that = this;
        that.pcPayLoading= true;
        hoteltradePay(Params)
          .then(function (response) {
            if (response.code == "200") {
              if (response.data.code == "0") {
                that.PayOrderInfo.confirmFlag = true;
                that.PayOrderInfo.confirmMsg = that.$t("PAYORDERPAGE.PaymentSucceeded");
              } else {
                that.$message({
                  showClose: true,
                  message: response.data.msg,
                  type: 'warning',
                  center: true,
                  offset:500
                });
              }
            } else {
              that.PayOrderInfo.confirmFlag = true;
              that.PayOrderInfo.confirmMsg = that.$t("PAYORDERPAGE.PaymentFailed");
            }
            that.pcPayLoading= false;
          });
      }
    },
    clearNoNumCaptcha() {
      this.KQPayInfo.captcha = this.KQPayInfo.captcha.toString().replace(/\D/g, '');
    },
    inputPayMenthod(id){
      const payGatewayMap = {
        1: "Hotel_Alipay",
        2: "Hotel_WeiXinPay",
        3: "Hotel_CNY_ProtocolPay",
        4: "Hotel_CNY_ProtocolPay_CTA",
      };
      const payGateway = payGatewayMap[id] || "";
      this.PayOrderInfo.getSwipeRates(payGateway);
    },
    closeKQDialogLoading(){
      this.PayOrderInfo.closeLoading();
    }
  },
};
</script>

<style scoped>
body {
  background: #ffffff;
}
.grey_small_font {
  font-size: 1.4rem;
  font-family: PingFang SC, arial, helvetica,
    "helvetica neue", verdana, sans-serif;
  color: #6f787e;
}
nav {
  margin-top: 1.3rem;
  background-color: #ffffff;
}
#box3 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.s_btn_small_add {
  width: 17.6rem;
  background-color: #ffffff;
  color: #fc6640;
  border: 1px solid #fc6640;
}
.title-headerDivider {
  margin-bottom: 1rem;
  margin-top: -1rem;
  height: 2px;
  background-color: #fc6640;
}
::v-deep .el-dialog__header {
  padding: 10px 0 0 10px;
}
::v-deep .el-dialog__headerbtn {
  top: 12px;
}
::v-deep .el-dialog__body {
  position: relative;
  padding: 10px;
  text-align: center;
}
.add-guest-btn {
  padding: 8px 13px;
  background-color: #fc6640;
  color: #fff;
  pointer-events: auto;
}

.add-guest-div {
  position: absolute;
  top: -4rem;
  right: 10%;
  margin: 0;
  z-index: 1;
}
#qrcode-container {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 37rem;
  height: 10rem; /* 可以调整为你需要的高度 */
}
.item {
  padding-bottom: 1.5rem;
  border-bottom: 0.2rem dotted rgb(151, 151, 151);
}
.free_font{
  margin-left: 1.3rem; 
  padding-top: 1.3rem; 
  display: flex
}
.small_font {
  height: 2rem;
  font-size: 14px;
  color: #333f48;
  line-height: 2rem;
}
.label_name_text {
  width: 12.8rem;
}
</style>